module.exports = __webpack_public_path__ + "static/media/become_elf.70805b5c.svg";